import { Reveal } from "../landing/Reveal";

const CLUBS = [
  { emoji: "🤖", name: "AI Builders", members: "8.2K", online: "412 online", grad: "from-[#7C3AED] to-[#A78BFA]" },
  { emoji: "🍔", name: "Food Lovers", members: "12K", online: "890 online", grad: "from-[#F97316] to-[#22C55E]" },
  { emoji: "🚀", name: "Startup Club", members: "5.4K", online: "230 online", grad: "from-[#06B6D4] to-[#4ADE80]" },
  { emoji: "💼", name: "Placement Club", members: "15K", online: "1.2K online", grad: "from-[#22C55E] to-[#F97316]" },
  { emoji: "✈️", name: "Travel Club", members: "6.8K", online: "340 online", grad: "from-[#A78BFA] to-[#7C3AED]" },
  { emoji: "🎨", name: "Designers", members: "4.1K", online: "180 online", grad: "from-[#06B6D4] to-[#22C55E]" },
];

export const Communities = () => (
  <section id="communities" data-testid="communities-section" className="relative overflow-hidden py-20 sm:py-24">
    <div aria-hidden="true" className="absolute -left-32 top-1/3 h-[380px] w-[380px] rounded-full bg-[#7C3AED]/12 blur-[130px]" />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="font-jbmono text-xs uppercase tracking-[0.3em] text-[#06B6D4]">🧑‍🤝‍🧑 Communities</p>
        <h2 className="mt-3 max-w-xl font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
          Discord energy. Campus people.
        </h2>
      </Reveal>

      <div className="mt-12 grid grid-cols-2 gap-4 lg:grid-cols-3">
        {CLUBS.map((c, i) => (
          <Reveal key={c.name} delay={0.05 * i} className="h-full">
            <div
              data-testid={`club-${c.name.toLowerCase().replace(" ", "-")}`}
              className="group flex h-full items-center gap-4 rounded-3xl border border-white/10 bg-white/[0.04] p-5 backdrop-blur-xl transition-all duration-300 hover:-translate-y-1 hover:border-[#7C3AED]/50"
            >
              <span className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br text-2xl ${c.grad}`}>
                {c.emoji}
              </span>
              <div className="min-w-0 flex-1">
                <p className="truncate font-display text-base font-bold text-white sm:text-lg">{c.name}</p>
                <p className="font-jbmono text-[10px] text-slate-500">
                  {c.members} members · <span className="text-[#06B6D4]">{c.online}</span>
                </p>
              </div>
              <button className="shrink-0 rounded-full border border-white/15 px-4 py-2 text-xs font-bold text-slate-300 transition-colors group-hover:border-[#06B6D4] group-hover:bg-[#06B6D4] group-hover:text-[#09090B]">
                Join
              </button>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
